import { Box, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import StarBorder from "@mui/icons-material/StarBorder";
import NirantaraIcon from "../assets/images/vajra.svg";
import { miniSidebarElements } from "../utils/constant";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import scope1 from "../assets/images/Sidebar/scope1.svg";
import scope2 from "../assets/images/Sidebar/scope2.svg";
import scope3 from "../assets/images/Sidebar/scope3.svg";
import SidebarItemsRenderer from "../utils/layoutFunctions";
import { useUser } from "../context/AuthContext";
import {
  filterMiniSidebarElements,
  getRoleBasedSidebar,
} from "../utils/sidebarFunctions";
import { sidebarElements1, sidebarElementsFacility } from "../utils/constant";

const ApprovalSidebar = () => {
  const location = useLocation();
  const { user } = useUser();

  const [isHovered, setIsHovered] = useState(false);

  const mastersSidebarElements = [
    {
      text: "Scope 1",
      icon: scope1,
      path: "",
      children: [
        {
          text: "Stationary Combustion",
          icon: StarBorder,
          path: "/approval/scope1/stationary-combustion",
        },
        {
          text: "Mobile Combustion",
          icon: StarBorder,
          path: "/approval/scope1/mobile-combustion",
        },
        {
          text: "Fugitive Combustion",
          icon: StarBorder,
          path: "/approval/scope1/fugitive-combustion",
        },
      ],
    },
    {
      text: "Scope 2",
      icon: scope2,
      path: "/inbox",
      children: [
        {
          text: "Electricity",
          icon: StarBorder,
          path: "/approval/scope2/Electricity",
        },
        {
          text: "Heating and Cooling",
          icon: StarBorder,
          path: "/approval/scope2/Heat",
        },
        {
          text: "Steam",
          icon: StarBorder,
          path: "/approval/scope2/Steam",
        },
      ],
    },
    {
      text: "Scope 3",
      icon: scope3,
      path: "/inbox",
      children: [
        {
          text: "Purchase Goods and Services",
          icon: StarBorder,
          path: "/approval/scope3/goods-services",
        },
        {
          text: "Transportation and Distribution",
          icon: StarBorder,
          path: "/approval/scope3/transportation",
        },
        {
          text: "Employee Commute",
          icon: StarBorder,
          path: "/approval/scope3/employee-commute",
        },
        {
          text: "Business Travel",
          icon: StarBorder,
          path: "/approval/scope3/business-travel",
        },
        {
          text: "Waste Generated in Operations",
          icon: StarBorder,
          path: "/approval/scope3/waste-generated",
        },
        {
          text: "Capital Goods",
          icon: StarBorder,
          path: "/approval/scope3/capital-goods",
        },
        {
          text: "Upstream Leased Assets",
          icon: StarBorder,
          path: "/approval/scope3/upstream-leased-assets",
        },
        {
          text: "End of Life Treatment of Sold Products",
          icon: StarBorder,
          path: "/approval/scope3/eol-treatment-of-sold-products",
        },
        {
          text: "Processing of Sold Products",
          icon: StarBorder,
          path: "/approval/scope3/processing-of-sold-products",
        },
        {
          text: "Use of Sold Products",
          icon: StarBorder,
          path: "/approval/scope3/use-of-sold-products",
        },
        {
          text: "Downstream Leased Assets",
          icon: StarBorder,
          path: "/approval/scope3/downstream-leased-assets",
        },
        {
          text: "Franchises",
          icon: StarBorder,
          path: "/approval/scope3/franchises",
        },
        // {
        //   text: "Investments",
        //   icon: StarBorder,
        //   path: "/approval/scope3/investments",
        // },
     
      ],
    },
    {
      text: "Scope 4",
      icon: scope2,
      path: "/inbox",
      children: [
 
        {
          text: "Carbon Avoidance",
          icon: StarBorder,
          path: "/approval/scope4/CarbonAvoidance",
        },
        {
          text: "Carbon Offsetting",
          icon: StarBorder,
          path: "/approval/scope4/CarbonOffsetting",
        },
      ],
    }
  ];

  const [open, setOpen] = useState(() => {
    const activeHeader = mastersSidebarElements.find((item) =>
      item.children?.some((child) => child.path === location.pathname)
    );
    return activeHeader
      ? {
          index: mastersSidebarElements.indexOf(activeHeader),
          header: activeHeader.text,
        }
      : {};
  });

  const sidebarElements = getRoleBasedSidebar({
    user,
    sidebarElements1,
    sidebarElementsFacility,
  });

  const filteredSidebar = sidebarElements.map((item) => {
    if (item.path === "/production-revenue") {
      return {
        ...item,
        heading: user?.companyAdmin ? "Production & Revenue" : "Production",
      };
    }
    if (item.heading === "Setup" && item.subData) {
      const newSubData = item.subData.filter(
        (sub) => sub.primary !== "Facility Master" || !user?.facility
      );
      return { ...item, subData: newSubData };
    }
    return item;
  });

  const miniSidebarFiltered = filterMiniSidebarElements({
    user,
    miniSidebarElements,
  });

  const handleClick = (item, index) => {
    setOpen((prevOpen) =>
      prevOpen.index === index ? {} : { index, header: item.text }
    );
  };

  const renderMainSidebarItems = (elements) => {
    return elements.map((item, index) => (
      <div
        key={index}
        style={{
          fontFamily: "Inter",
          display: "flex",
          flexDirection: "column",
          marginTop: "0.25rem",
        }}
      >
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor:
              item.primary === "Approval" ? "#488257" : "transparent",
          }}
        >
          <Tooltip
            title={item.title}
            arrow
            placement="bottom-start"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  color: "#fff",
                  fontSize: "12px",
                  borderRadius: "4px",
                  padding: "0.25rem 0.5rem",
                },
                arrow: {
                  color: "#fff",
                },
              },
            }}
          >
            <a
              href={item.path}
              key={item.primary}
              style={{
                textDecoration: "none",
                color: "green",
                padding: "0.4rem",
                borderRadius: "4px",
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={"img"}
                sx={{
                  width: "24px",
                  height: "24px",
                  filter:
                    item.primary === "Approval" ? "invert(1)" : "invert(0)",
                }}
              />
            </a>
          </Tooltip>
        </div>
      </div>
    ));
  };

  const renderSecondarySidebarItems = (elements, heading) => {
    return (
      <div style={{ width: "100%", fontFamily: "Inter", marginTop: "1.5rem" }}>
        {heading && (
          <p
            style={{
              color: "#fff",
              fontWeight: "700",
              fontSize: "22px",
              padding: "0 1rem 0.5rem 0.5rem",
              marginLeft: "0.5rem",
              borderBottom: "2px solid #fff",
              display: "inline-block",
            }}
          >
            {heading}
          </p>
        )}
        {elements.map((item, index) => {
          const isChildSelected =
            item.children &&
            item.children.some((child) => location.pathname === child.path);

          return item.heading ? (
            <p
              key={`heading-${index}`}
              style={{
                color: "rgba(255, 255, 255, 1)",
                paddingLeft: "1rem",
                marginBottom: "0.5rem",
                marginTop: "1rem",
                fontFamily: "Public Sans",
                fontSize: "11px",
                fontWeight: 400,
                lineHeight: "14px",
              }}
            >
              {item.heading}
            </p>
          ) : (
            <div key={`item-${index}`}>
              <Link
                to={item.path}
                onClick={(e) => {
                  if (item.children) {
                    e.preventDefault();
                    handleClick(item, index);
                  } else {
                    // navigate(item.path);
                  }
                }}
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname === item.path || isChildSelected
                      ? "#488257"
                      : "#ffffff",
                  display: "flex",
                  padding: "0.5rem",
                  margin: "4px 8px",
                  backgroundColor:
                    location.pathname === item.path || isChildSelected
                      ? "#ffffff"
                      : "transparent",
                  borderRadius: "4px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Box
                  component="img"
                  src={item.icon}
                  alt={"img"}
                  sx={{
                    filter:
                      location.pathname === item.path || isChildSelected
                        ? "invert(35%) sepia(22%) saturate(750%) hue-rotate(90deg) brightness(130%) contrast(100%)"
                        : "invert(1)",
                    width: "1rem",
                    height: "1rem",
                  }}
                />
                <span
                  style={{
                    marginLeft: "1rem",
                    fontSize: "16px",
                    fontWeight: "400",
                    color:
                      location.pathname === item.path || isChildSelected
                        ? "#488257"
                        : "#ffffff",
                  }}
                >
                  {item.text}
                </span>
                {item.children && (
                  <span style={{ marginLeft: "auto", fontSize: "16px" }}>
                    {open?.header === item.text ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </span>
                )}
              </Link>
              {item.children && open?.header === item.text && (
                <div style={{ paddingLeft: "0.5rem" }}>
                  {item.children.map((child, childIndex) => (
                    <Link
                      key={`child-${childIndex}`}
                      to={child.path}
                      onClick={(e) => {
                        // navigate(child.path);
                      }}
                      style={{
                        textDecoration: "none",
                        color: "#ffffff",
                        display: "flex",
                        padding: "0.5rem 0 0.5rem 0.5rem",
                        margin: "4px 8px",
                        borderRadius: "4px",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {location.pathname === child.path ? (
                        <CheckCircleOutlineIcon
                          style={{
                            width: "16px",
                          }}
                        />
                      ) : (
                        <RadioButtonUncheckedIcon
                          style={{
                            width: "16px",
                          }}
                        />
                      )}
                      <span
                        style={{
                          marginLeft: "0.5rem",
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "inherit",
                        }}
                      >
                        {child.text}
                      </span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Box style={{ display: "flex" }}>
        <div
          style={{
            width: "22.5%",
            height: "100vh",
            backgroundColor: "#E6E6E6",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Box display="flex" justifyContent="center" p={2}>
            <img
              src={NirantaraIcon}
              alt="Nirantara Logo"
              style={{ cursor: "pointer", height: "36px" }}
            />
          </Box>
          <div style={{ width: "100%" }}>
            {renderMainSidebarItems(miniSidebarFiltered)}
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "21.25vw",
              height: "100vh",
              backgroundColor: "#fff",
              zIndex: 10,
              overflowY: "auto",
              transform: isHovered ? "translateX(0)" : "translateX(-100%)",
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.4s ease, transform 0.4s ease",
              pointerEvents: isHovered ? "auto" : "none",
              willChange: "transform, opacity",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {<SidebarItemsRenderer elements={filteredSidebar} />}
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#488257",
            width: "77.5%",
          }}
        >
          {renderSecondarySidebarItems(mastersSidebarElements, "Approval")}
        </div>
      </Box>
    </>
  );
};

export default ApprovalSidebar;
